import { useEffect, useRef } from 'react'
import Style from './index.module.less'
import * as echarts from 'echarts'
import { type Block } from '@/hoxStore/interface'
import { isEqual } from 'radash'
import { getUniqueHeightObjects } from '@/views/Home/components/LatestBlock/utils'
import classNames from 'classnames'
import { useGlobalStore } from '@/hoxStore/globalStore'

const RealtimeTransaction = ({ blockNext = [] }: { blockNext: Block[] }) => {
  const blocks: Block[] = JSON.parse(JSON.stringify(blockNext || []))
  const { curReponsive } = useGlobalStore()
  // 柱
  const chartsEl = useRef<HTMLDivElement>(null)
  // 線
  const chartsE2 = useRef<HTMLDivElement>(null)
  const chartsE3 = useRef<HTMLDivElement>(null)
  // 柱
  const myChart = useRef<any>(null)
  // 線
  const myChart2 = useRef<any>(null)
  const myChart3 = useRef<any>(null)
  const currentTransitions = useRef<Block[]>(blocks.reverse())
  const categoriesData = blocks.reverse().map((item) => {
    return `${item.height}`
  })
  // 新增一個數據進去
  categoriesData.push('first')
  const categories = useRef<string[]>(categoriesData)
  const dataData = blocks.reverse().map((item) => {
    return {
      value: item.num_txs + 1,
    }
  })
  // 新增一個數據進去
  dataData.push({ value: dataData[dataData.length - 1].value })
  const data = useRef<{ value: number; itemStyle?: { color: string } }[] | number[]>(dataData)
  useEffect(() => {
    if (isEqual(currentTransitions.current, blocks.reverse())) {
      return
    }
    if (data.current.length > 10) {
      // 刪除新增的配置數據
      categories.current.pop()
      data.current.pop()
    }
    const arr = getUniqueHeightObjects(currentTransitions.current, blocks.reverse())
    data.current.splice(0, arr.length)
    categories.current.splice(0, arr.length)
    currentTransitions.current = blocks.reverse()

    setTimeout(() => {
      data.current.forEach((item) => {
        if (typeof item === 'object') {
          delete item.itemStyle
        }
      })
      arr.forEach((item) => {
        ;(data.current as any).push({
          value: item.num_txs + 1,
        })
        categories.current.push(`${item.height}`)
      })
      // 新增配置數據
      //   data.current.push({ value: (data.current[data.current.length - 1] as any).value } as any)
      const maxValue = getMaxValue(data.current)

      data.current.push({ value: maxValue <= 4 ? 1 : maxValue } as any)
      categories.current.push('first')
      myChart.current.setOption(option)
      myChart2.current.setOption(option2)
      myChart3.current.setOption(option3)
    }, 0)
  }, [blocks])

  const getMaxValue = (data: any) => {
    const value = Math.max(...data.map((item: any) => item.value))
    if (value > 1) return value
    return 4
  }

  // 柱
  const option = {
    selectedMode: true,
    // 提示框配置
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow', // 阴影指示器
      },
      className: 'cus_tip_formatter',
      position: (point: any, index: any) => {
        if (curReponsive?.size === 'mobile') {
          if (index[0].dataIndex > 6) {
            return [point[0] - 100, '10%']
          }
          return [point[0], '10%']
        } else {
          if (index[0].dataIndex === 9) {
            return [point[0] - 70, '10%']
          }
          return [point[0], '10%']
        }
      },
      formatter: (val: any) => {
        console.log('val', val[0].name === 'first')
        if (val[0].name === 'first') return null
        return `<div id="cus_tip_formatter">
          <div class='font_14'>
          ${val[0].axisValueLabel}
          </div>
          <div class='font_14'>
          ${val[0].value - 1} TX
          </div>
          </div>`
      },
    },

    // 网格配置
    grid: {
      top: '20%',
      left: '0%',
      right: '0%',
      bottom: '15px',
      // containLabel: true,
    },

    // X轴配置
    xAxis: {
      show: false,
      type: 'category',
      data: categories.current,
      axisLine: {
        lineStyle: {
          color: '#999',
        },
      },
      axisLabel: {
        interval: 0,
        rotate: 0, // 标签旋转角度
        color: '#666',
      },
      axisTick: {
        alignWithLabel: true,
      },
    },

    // Y轴配置
    yAxis: {
      show: false,
      type: 'value',
      name: '',
      min: 0,
      max: getMaxValue(data.current),
      interval: 1,
      nameTextStyle: {
        color: '#666',
        padding: [0, 0, 0, 0], // 上右下左
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: '#999',
        },
      },
      axisTick: {
        show: true,
      },
      axisLabel: {
        color: '#666',
        show: true,
      },
      splitLine: {
        lineStyle: {
          type: 'dashed',
          color: '#eee',
        },
      },
    },

    // 数据系列配置
    series: [
      {
        cursor: 'default',
        name: '实时区块',
        type: 'bar',
        barWidth: '25', // 柱条宽度
        data: data.current,
        itemStyle: {
          color: function (params: any) {
            // if (params.dataIndex === 0) return '#f3fbf9'
            return params.dataIndex % 2 === 0 ? '#61FFA9' : '#08C284'
          },
          borderRadius: [0, 0, 0, 0], // 柱条圆角
          shadowColor: 'rgba(0, 0, 0, 0.3)',
        },
        // 鼠标悬停样式
        emphasis: {
          itemStyle: {
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    ],
    // 响应式配置
    responsive: true,
  }

  const option2 = {
    // 提示框配置
    // 网格配置
    grid: {
      top: '15%',
      left: '0%',
      right: '0%',
      bottom: '15px',
      // containLabel: true,
    },

    // X轴配置
    xAxis: {
      show: false,
      type: 'category',
      data: categories.current,
      axisLine: {
        lineStyle: {
          color: '#999',
        },
      },
      axisLabel: {
        interval: 0,
        rotate: 0, // 标签旋转角度
        color: '#666',
      },
      axisTick: {
        alignWithLabel: true,
      },
    },

    // Y轴配置
    yAxis: {
      show: false,
      type: 'value',
      name: '',
      min: 0,
      max: getMaxValue(data.current),
      interval: 1,
      nameTextStyle: {
        color: '#666',
        padding: [0, 0, 0, 0], // 上右下左
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: '#999',
        },
      },
      axisTick: {
        show: true,
      },
      axisLabel: {
        color: '#666',
        show: true,
      },
      splitLine: {
        lineStyle: {
          type: 'dashed',
          color: '#eee',
        },
      },
    },

    // 数据系列配置
    series: [
      {
        type: 'line',
        smooth: true,
        data: data.current,
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: 'rgba(34, 255, 189, 0.9)' },
            { offset: 1, color: 'rgba(255, 255, 255, 0.2)' },
          ]),
        },
        lineStyle: {
          width: 0,
        },
        symbol: 'none',
      },
    ],
    // 响应式配置
    responsive: true,
  }

  const option3 = {
    // 提示框配置
    // 网格配置
    grid: {
      top: '15%',
      left: '0%',
      right: '0%',
      bottom: '15px',
      // containLabel: true,
    },

    // X轴配置
    xAxis: {
      show: false,
      type: 'category',
      data: categories.current,
      axisLine: {
        lineStyle: {
          color: '#999',
        },
      },
      axisLabel: {
        interval: 0,
        rotate: 0, // 标签旋转角度
        color: '#666',
      },
      axisTick: {
        alignWithLabel: true,
      },
    },

    // Y轴配置
    yAxis: {
      show: false,
      type: 'value',
      name: '',
      min: 0,
      max: getMaxValue(data.current),
      interval: 1,
      nameTextStyle: {
        color: '#666',
        padding: [0, 0, 0, 0], // 上右下左
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: '#999',
        },
      },
      axisTick: {
        show: true,
      },
      axisLabel: {
        color: '#666',
        show: true,
      },
      splitLine: {
        lineStyle: {
          type: 'dashed',
          color: '#eee',
        },
      },
    },

    // 数据系列配置
    series: [
      {
        type: 'line',
        smooth: true,
        data: data.current,
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: 'rgba(119, 213, 255, 0.9)' },
            { offset: 1, color: 'rgba(255, 255, 255, 0.9)' },
          ]),
        },
        lineStyle: {
          width: 0,
        },
        symbol: 'none',
      },
    ],
    // 响应式配置
    responsive: true,
  }

  const chartResize = () => {
    if (myChart.current) {
      setTimeout(() => {
        myChart.current?.resize()
        myChart2.current?.resize()
      }, 200)
    }
  }

  useEffect(() => {
    const timeId = setTimeout(() => {
      myChart.current = echarts.init(chartsEl.current as HTMLElement)
      myChart.current.setOption(option)
      myChart2.current = echarts.init(chartsE2.current as HTMLElement)
      myChart2.current.setOption(option2)
      myChart3.current = echarts.init(chartsE3.current as HTMLElement)
      myChart3.current.setOption(option3)
      clearTimeout(timeId)
    }, 0)

    window.addEventListener('resize', chartResize)
    return () => {
      window.removeEventListener('resize', chartResize)
    }
  }, [])
  return (
    <div
      className={classNames({
        [Style.wrap]: true,
        transition_slide_wrap: true,
      })}
    >
      {curReponsive?.size !== 'mobile' ? <div className={Style.LeftMask}></div> : null}
      <div
        className={classNames({
          [Style.column_bar_line2]: true,
        })}
        ref={chartsE3}
      ></div>
      <div
        className={classNames({
          [Style.column_bar_line]: true,
        })}
        ref={chartsE2}
      ></div>
      <div className={Style.column_bar} ref={chartsEl}></div>
      {curReponsive?.size !== 'mobile' ? <div className={Style.RightMask}></div> : null}
    </div>
  )
}

export default RealtimeTransaction
